// removed by extract-text-webpack-plugin
module.exports = {"articleWrapper":"bjKSN5BD8phHLo60sO8BX","title":"_3Q1jIR0L126RyqS3iJG5Ps","description":"-o4S5qhexJARIS98OAWLI","creationBlock":"_3jAajxSpDWsrq-dMTLfiHU","shareBlock":"fu1Za4O6jc-d0Yb6cz5qs","topPart":"_2tM6pPCNM7CG4TMMaahEMR","articleBody":"nOSjymvVYqxYUJnrFWu64"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/SingleArticlePage/SingleArticlePage.scss
// module id = 1853
// module chunks = 0